export default Object.freeze({
  MINIMUM_AGE: 2.07,
  MAXIMUM_AGE: 3.02,
  VALIDATION_AGE: 2.11
});
